import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, NavLink } from 'react-router-dom';
import Login from './pages/Login';
import Overview from './pages/Overview';
import Reports from './pages/Reports';
import Receipts from './pages/Receipts';
import IssueReceipt from './pages/IssueReceipt';

const isAuthenticated = () => !!localStorage.getItem('portal_token');

function PrivateRoute({ children }: { children: React.ReactNode }) {
  return isAuthenticated() ? <>{children}</> : <Navigate to="/login" />;
}

function Layout({ children }: { children: React.ReactNode }) {
  const user = JSON.parse(localStorage.getItem('portal_user') || '{}');
  const logout = () => {
    localStorage.removeItem('portal_token');
    localStorage.removeItem('portal_user');
    window.location.href = '/login';
  };

  const navStyle = ({ isActive }: { isActive: boolean }) => ({
    display: 'block', padding: '10px 16px', borderRadius: 6, fontSize: 14,
    textDecoration: 'none', marginBottom: 4,
    background: isActive ? '#E6F1FB' : 'transparent',
    color: isActive ? '#185FA5' : '#555',
    fontWeight: isActive ? 500 : 400,
  });

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f4f6f9' }}>
      {/* Sidebar */}
      <div style={{ width: 220, background: 'white', borderRight: '0.5px solid #e0e0e0', padding: '24px 12px', display: 'flex', flexDirection: 'column' }}>
        <div style={{ marginBottom: 32, paddingLeft: 8 }}>
          <img src="/logo.jpg" alt="Linear Locker Solutions" style={{ width: 160, display: 'block', marginBottom: 8 }} />
          <div style={{ fontSize: 11, color: '#aaa', paddingLeft: 2 }}>Customer Portal</div>
        </div>
        <nav style={{ flex: 1 }}>
          <NavLink to="/" end style={navStyle}>Overview</NavLink>
          <NavLink to="/reports" style={navStyle}>Reports</NavLink>
          <NavLink to="/receipts" style={navStyle}>Receipts</NavLink>
          <NavLink to="/issue" style={navStyle}>Issue Receipt</NavLink>
        </nav>
        <div style={{ borderTop: '0.5px solid #e0e0e0', paddingTop: 16, paddingLeft: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 2 }}>{user.name}</div>
          <div style={{ fontSize: 12, color: '#888', marginBottom: 12 }}>{user.email}</div>
          <button onClick={logout}
            style={{ padding: '7px 16px', background: 'transparent', border: '0.5px solid #ccc', borderRadius: 6, fontSize: 13, cursor: 'pointer', color: '#666', width: '100%' }}>
            Sign out
          </button>
        </div>
      </div>
      {/* Main content */}
      <div style={{ flex: 1, padding: 32, maxWidth: 1100 }}>
        {children}
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Layout><Overview /></Layout></PrivateRoute>} />
        <Route path="/reports" element={<PrivateRoute><Layout><Reports /></Layout></PrivateRoute>} />
        <Route path="/receipts" element={<PrivateRoute><Layout><Receipts /></Layout></PrivateRoute>} />
        <Route path="/issue" element={<PrivateRoute><Layout><IssueReceipt /></Layout></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  );
}
